import { render, staticRenderFns } from "./HotelInfo.vue?vue&type=template&id=aa99bc30&"
import script from "./HotelInfo.vue?vue&type=script&lang=ts&"
export * from "./HotelInfo.vue?vue&type=script&lang=ts&"
import style0 from "./HotelInfo.vue?vue&type=style&index=0&id=aa99bc30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports